export interface ModuleErrorView {
  code: string;
  message: string;
  httpStatus?: number;
  recoverable: boolean;
}

export function createModuleError(
  code: string,
  message: string,
  options: { httpStatus?: number; recoverable?: boolean } = {}
): ModuleErrorView {
  return {
    code,
    message,
    httpStatus: options.httpStatus,
    recoverable: options.recoverable !== false,
  };
}
